import { Account } from "../../model/account.model";

export interface IUser {
  id?: any;
  login?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  activated?: boolean;
  langKey?: string;
  authorities?: any[];
  createdBy?: string;
  createdDate?: Date;
  lastModifiedBy?: string;
  lastModifiedDate?: Date;
  password?: string;
  rules?: Array<IRuleDmp>;
}

export class User implements IUser {
  static build(d: any): User {
    const user = new User(
    d.id, d.login, d.firstName, d.lastName, d.email, d.activated, d.langKey
    , d.authorities, d.createdBy, d.createdDate, d.lastModifiedBy, d.lastModifiedDate,
    d.password , d.rules);
    return user;
  }
  constructor(
    public id?: any,
    public login?: string,
    public firstName?: string,
    public lastName?: string,
    public email?: string,
    public activated?: boolean,
    public langKey?: string,
    public authorities?: string[],
    public createdBy?: string,
    public createdDate?: Date,
    public lastModifiedBy?: string,
    public lastModifiedDate?: Date,
    public password?: string,
    public rules?: Array<RuleDmp>
  ) {
    this.id = id ? id : null;
    this.login = login ? login : null;
    this.firstName = firstName ? firstName : null;
    this.lastName = lastName ? lastName : null;
    this.email = email ? email : null;
    this.activated = activated ? activated : false;
    this.langKey = langKey ? langKey : null;
    this.authorities = authorities ? authorities : null;
    this.createdBy = createdBy ? createdBy : null;
    this.createdDate = createdDate ? createdDate : null;
    this.lastModifiedBy = lastModifiedBy ? lastModifiedBy : null;
    this.lastModifiedDate = lastModifiedDate ? lastModifiedDate : null;
    this.password = password ? password : null;
    this.rules = rules ? rules : [];
  }
  hasTenant(tenant: string){
    return this.authorities.includes("ROLE_ADMIN") || this.rules.findIndex(p => p.tenant == tenant) > -1;
  }
  hasPartner(tenant: string, partner: string){
    return this.authorities.includes("ROLE_ADMIN") || (
      this.rules.filter(p => p.tenant == tenant)
                  .filter(p => p.partner == "" || p.partner == partner)
    );
  }
  hasTenantWithWrite(tenant: string){
    return this.authorities.includes("ROLE_ADMIN") || 
      this.rules.findIndex(p => p.tenant == tenant && p.rule == 'WRITE') > -1;
  }
  hasPartnerWithWrite(tenant: string, partner: string){
    return this.authorities.includes("ROLE_ADMIN") || (
      this.rules.filter(p => (p.tenant == tenant) && p.rule == 'WRITE')
                  .filter(p => p.partner == "" || p.partner == partner)
    );
  }
}


export interface IRuleDmp {
  authority?: string,
	tenant?: string,
	partner?: string
}
export class RuleDmp implements IRuleDmp {
  constructor(
    public rule?: string,
    public tenant?: string,
    public partner?: string){
      this.rule = rule ? rule : null;
      this.tenant = tenant ? tenant : null;
      this.partner = partner ? partner : null;
  }
}